import { render, staticRenderFns } from "./RepeatFreqInterval.vue?vue&type=template&id=f23e253a&scoped=true"
import script from "./RepeatFreqInterval.vue?vue&type=script&lang=js"
export * from "./RepeatFreqInterval.vue?vue&type=script&lang=js"
import style0 from "./RepeatFreqInterval.vue?vue&type=style&index=0&id=f23e253a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23e253a",
  null
  
)

export default component.exports